import openSocket from "socket.io-client";
import { getBackendUrl } from "../config";

function connectToSocket() {
    const token = localStorage.getItem("token");
    return openSocket(getBackendUrl(), {
      transports: ["websocket", "polling", "flashsocket"],
      // El JWT se envía durante la autenticación,
      // no como parámetro en la URL.
      auth: {
        token: token ? JSON.parse(token) : null,
      },
    });
}

export default connectToSocket;